
      const org = {
  "orgName": "Организация",
  "integrator": "Интегратор",
  "orgDescription": "Описание",
  "integratorDescription": "Описание",
  "orgAddress": "Адрес",
  "integratorAddress": "Адрес",
  "createTime": "Создать время",
  "linkMan": "Назначить",
  "phone": "Номер телефона",
  "email": "Электронная почта",
  "usefulLife": "Период эксплуатации",
  "parentName": "Вышестоящая организация",
  "orgNameRequired": "Требуется название организации",
  "integratorRequired": "Требуется название интегратора",
  "orgNameRule": "Не должно превышать 30 символов",
  "integratorRule": "Не должно превышать 30 символов",
  "orgDescriptionRequired": "Требуется описание организации",
  "integratorDescriptionRequired": "Требуется описание интегратора",
  "orgDescriptionRule": "Не должно превышать 200 символов",
  "integratorDescriptionRule": "Не должно превышать 200 символов",
  "phoneRule": "Введите корректный номер телефона",
  "emailRule": "Введите корректный Email",
  "linkManRule": "Не должно превышать 20 символов",
  "nickNameRequired": "Требуется псевдоним",
  "nickNameRule": "Не должно превышать 20 символов",
  "userNameRequired": "Требуется имя пользователя",
  "userNameRule": "Не должно превышать 20 символов",
  "passwordRequired": "Требуется пароль",
  "passwordRule": "Длина пароля от 6 до 20 символов",
  "confirmPasswordRequired": "Введите пароль повторно",
  "confirmPasswordRule": "Пароли не совпадают",
  "editBasicInfo": "Модификация базовой информации",
  "userInfo": "Информация пользователя",
  "password": "Пароль",
  "confirmPassword": "Подтвердить",
  "editUserInfo": "Изменить информацию о пользователе",
  "userName": "Имя пользователя",
  "role": "Роль",
  "nickName": "Псевдоним",
  "autoRefresh": "Вход",
  "avatar": "Изображение",
  "refresh": "Да",
  "autoOver": "Нет",
  "locationInfo": "Местоположение",
  "smsService": "SMS сервис",
  "recharge": "Перезаряд",
  "smsNum": "SMS",
  "isShare": "Объеденить",
  "receiveUser": "Принять пользователя",
  "receivePhone": "Принять телефон",
  "rechargeSms": "Оплата SMS",
  "topUp": "Пополнение счета",
  "recycle": "Удалить",
  "smsLabel": "Пожалуйста введите номер",
  "rechargeSuccess": "Успешная оплата SMS",
  "errData": "Введены некорректные данные",
  "customInfo": "Информация пользователя",
  "systemName": "Название системы",
  "systemLogo": "Логотип системы",
  "entityTemplate": "Шаблон",
  "enableShare": "Включить объединение SMS",
  "disableShare": "Отключить объединение SMS",
  "pre": "Предыдущий",
  "next": "Следующий",
  "addOrgSuccess": "Новая организация успешно создана",
  "newUser": "Новые пользователи",
  "move": "Переход к",
  createUser:'Новые пользователи',
  scenes:'Сценарий ассоциации',
  TopOrg:'Высшие учреждения',
Org:'Субъекты',
Attach:'Допользователь',
}
      export default org
    